module.exports = __webpack_public_path__ + "static/footer-2-e1ca2c658602f7c9cd41aeb53d2516c7.mp4";